import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card'
import Button from '@mui/material/Button';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import MDPagination from 'components/MDPagination';
import Icon from '@mui/material/Icon';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import DataTable from 'examples/Tables/DataTable';
import { apiGetBranches, apiExcelBranch, apiDeleteBranch } from '../../api/branch.api'; // API 호출 함수 임포트
import confirmHardDelete from 'utils/confirmHardDelete';
import MDBadge from "components/MDBadge";
import { useNavigate } from 'react-router-dom';
import { useData } from '../../hooks';
import TopNavbar from 'examples/Navbars/TopNavbar';

const Branches = () => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const { user, appIsReady } = useData();
  const [searchcond, setSearchcond] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    if (appIsReady && user) {
      fetchBranches(page);
    }
  }, [page, user, appIsReady]);

  const fetchBranches = async (pageNum) => {
    setLoading(true);
    try {
      const response = await apiGetBranches(pageNum, 10, user.accessToken, searchcond); // 페이지 당 10개의 지점 데이터 불러오기
      if (response && response.data) {
        setBranches(response.data);
        setTotal(response.total); // 전체 데이터 수 설정
      } else {
        console.log('No data received');
      }
    } catch (error) {
      console.error('Failed to load branches:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pageNum) => {
    setPage(pageNum);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleString('ko-KR', options).replace(/. /g, '-').replace('.', '').replace(' ', ' ').slice(0, 10);
  };

  const handleEditClick = (branch) => {
    navigate('/branch/edit', { state: { branchdata: branch } });
  };

  const handleSearchChange = (event) => {
    setSearchcond(event.target.value);
  };

  const handleSearchSubmit = (event) => {
      console.log("searchSumit")
      fetchBranches(1); // 새로운 검색 조건으로 검색 시 페이지 번호를 1로 초기화
      setPage(1);
  };

  /**
   * 지점 삭제. 🔴 지점에는 기기와 적립 이력이 딸려 있다.
   *    서버는 softDelete 라 `deletedAt` 을 비우면 되살아나지만,
   *    목록에서 사라지면 아무도 눈치채지 못하므로 2단계로 확인받는다.
   */
  const handleDeleteClick = async (branch) => {
    if (!confirmHardDelete(`지점 '${branch.branch_name}'`)) return;
    try {
      await apiDeleteBranch(branch.id, user.accessToken);
      fetchBranches(page);
    } catch (e) {
      alert('삭제에 실패했습니다. 잠시 후 다시 시도해 주세요.');
    }
  };

  const rows = branches.map(branch => ({
    id: branch.id,
    branch_name: branch.branch_name,
    owner_userid: branch.owner_userid,
    owner_name: branch.owner_name,
    owner_phone: branch.owner_phone,
    branch_sido: branch.branch_sido,
    branch_addr: branch.branch_addr,
    use_time: branch.use_time,
    setup_date: formatDate(branch.setup_date),
    information: branch.information,
    esg: branch.isESG ? 
      <MDBox ml={-1}>
        <MDBadge badgeContent="활성화" color="success" variant="gradient" size="sm" />
      </MDBox> : 
      <MDBox ml={-1}>
        <MDBadge badgeContent="비활성화" color="dark" variant="gradient" size="sm" />
      </MDBox>,
    status: branch.status === 'on' ? 
      <MDBox ml={-1}>
        <MDBadge badgeContent="online" color="success" variant="gradient" size="sm" />
      </MDBox> : 
      <MDBox ml={-1}>
        <MDBadge badgeContent="offline" color="dark" variant="gradient" size="sm" />
      </MDBox>,
    edit: 
      <Button 
        variant="contained" 
        color="success" 
        size="small" 
        onClick={() => handleEditClick(branch)}
      >
        수정
      </Button>,
    remove:
      <Button
        variant="outlined"
        color="error"
        size="small"
        onClick={() => handleDeleteClick(branch)}
      >
        삭제
      </Button>
  }));

  const columns = [
    { Header: "ID", accessor: "id", align: "left" },
    { Header: "지점명", accessor: "branch_name", align: "left" },
    { Header: "소유자 ID", accessor: "owner_userid", align: "left" },
    { Header: "소유자 이름", accessor: "owner_name", align: "left" },
    { Header: "소유자 전화번호", accessor: "owner_phone", align: "left" },
    { Header: "시/도", accessor: "branch_sido", align: "left" },
    { Header: "주소", accessor: "branch_addr", align: "left" },
    { Header: "사용 시간", accessor: "use_time", align: "left" },
    { Header: "설치 날짜", accessor: "setup_date", align: "left" },
    { Header: "정보", accessor: "information", align: "left" },
    { Header: "ESG", accessor: "esg", align: "center" },
    { Header: "상태", accessor: "status", align: "left" },
    { Header: "수정", accessor: "edit", align: "center" },
    { Header: "삭제", accessor: "remove", align: "center" },
  ];

  const totalPages = Math.ceil(total / 10);

  
  const handleDownloadExcel = async () => {
    try {
    
      const currentSearchCond = searchcond || "";
        // 엑셀 파일 데이터 가져오기
      const response = await apiExcelBranch(user.accessToken, currentSearchCond);
      console.log(response);
         // JSON 응답을 텍스트로 읽기
    const jsonText = await response.text();
    const jsonData = JSON.parse(jsonText);
    
    // 버퍼 데이터 추출
    const bufferData = jsonData.data.data;
    
    // Uint8Array로 변환
    const uint8Array = new Uint8Array(bufferData);
    
    // 올바른 MIME 타입으로 Blob 생성
    const excelBlob = new Blob([uint8Array], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    
    // 다운로드 링크 생성
    const url = window.URL.createObjectURL(excelBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = '지점.xlsx';
    document.body.appendChild(a);
    a.click();
    
    // 정리
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
      } catch (error) {
        console.error('다운로드 실패:', error);
      }
};


  return (
    <DashboardLayout>
      <TopNavbar 
      searchlabel = "지점명,id,이름,전화번호,주소"
      onSearchChange={handleSearchChange}
      onSearchSubmit={handleSearchSubmit}
      />
      <MDBox display="flex" mr={2} justifyContent="right">
        <MDButton variant="gradient" color="success" onClick={() => navigate(`/branch/insert`)}>지점등록</MDButton>
        <MDButton variant="gradient" color="info" onClick={handleDownloadExcel} sx={{ ml: 2 }}>엑셀 다운로드</MDButton>
      </MDBox>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  지점관리
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                  loading={loading}
                />
              </MDBox>
              
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                justifyContent="center"
                alignItems={{ xs: "flex-start", sm: "center" }}
                p={3}
              >
                <MDPagination
                  variant="gradient"
                  color="info"
                >
                  {page > 1 && (
                    <MDPagination item onClick={() => handlePageChange(page - 1)}>
                      <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
                    </MDPagination>
                  )}
                  {Array.from({ length: totalPages }, (_, index) => (
                    <MDPagination
                      item
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      active={page === index + 1}
                    >
                      {index + 1}
                    </MDPagination>
                  ))}
                  {page < totalPages && (
                    <MDPagination item onClick={() => handlePageChange(page + 1)}>
                      <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
                    </MDPagination>
                  )}
                </MDPagination>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default Branches;
